import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  value: null,
};

export const SeletedapplicantIdsSlice = createSlice({
  name: 'SeletedApplicantIds',
  initialState,
  reducers: {
    updateApplicantId: (state, action) => {
      state.value = action.payload;
    },
  },
});

export const { updateApplicantId } = SeletedapplicantIdsSlice.actions;

export default SeletedapplicantIdsSlice.reducer;
